import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { AppContext } from 'src/components/app-context';
import type { AppState } from 'src/reducers';
import type { PriceListProps } from './types';
import { PriceListPanel } from './price-list-panel';
import { PriceListPanelWrapper } from './styles';

export const PriceList: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<PriceListProps>>
> = props => {
  const { priceList, campaign } = props;
  const me = useSelector((state: AppState) => state.areas.account.me);

  const { market } = useContext(AppContext);
  return (
    <PriceListPanelWrapper>
      <PriceListPanel
        me={me}
        showProductInformationTexts={market.showProductInformationTexts}
        storeStatistics={priceList?.meta?.storeStatistics}
        campaign={campaign}
      />
    </PriceListPanelWrapper>
  );
};
